import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Transitions from 'vue2-transitions'
import "./assets/styles/global.css";
import '@fortawesome/fontawesome-svg-core/styles.css'

Vue.config.productionTip = false

/* This callback runs before every route change, including on page load. */
router.beforeEach((to, from, next) => {
	/* This goes through the matched routes from last to first, finding the closest route with a title.
	** eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen. */
	const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

	/* Find the nearest route element with meta tags. */
	const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
	const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

	/* If a route with a title was found, set the document (page) title to that value. */
	if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

	/* Remove any stale meta tags from the document using the key attribute we set below. */
	Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

	/* Skip rendering meta tags if there are none. */
	if(!nearestWithMeta) return next();

	/* Turn the meta tag definitions into actual elements in the head. */
	nearestWithMeta.meta.metaTags.map(tagDef => {
	const tag = document.createElement('meta');

	Object.keys(tagDef).forEach(key => {
		tag.setAttribute(key, tagDef[key]);
	});

	/* We use this to track which meta tags we create, so we don't interfere with other ones. */
	tag.setAttribute('data-vue-router-controlled', '');

	return tag;
	})
	/* Add the meta tags to the document head. */
	.forEach(tag => document.head.appendChild(tag));

	next();
});

Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        var vm = vnode.context;
        var callback = binding.value;

        el.clickOutsideEvent = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                return callback.call(vm, event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});

Vue.use(Transitions)
new Vue({
	router,
	store,
	render: h => h(App),
	// created() {
	// 	this.$router.push('/roomi')
	// }
}).$mount('#app')
